<template>
    <div
        :key="key"
        class="tree-custom"
    >
        <el-tree
          ref="tree"
          :data="options"
          show-checkbox
          :default-expand-all="defaultExpandAll"
          node-key="id"
          highlight-current
          :props="defaultProps"
          :check-strictly="checkStrictly"
          :default-checked-keys="defaultCheckedkeys"
          :default-expanded-keys="defaultExpandedKeys"
          @check="handlerCheck"
        />
    </div>
</template>

<script>
export default {
  name: "TreeCustom",

  inheritAttrs: false,

  props: {
    value: {
      type: Array,
      default() {
        return [];
      }
    },
    defaultExpandedKeys: {
      type: Array,
      default() {
        return [];
      }
    },
    checkStrictly: {
      type: Boolean,
      default:true
    },
    defaultExpandAll: {
      type: Boolean,
      default:false
    },
    options: {
      type: Array,
      default() {
        return [];
      }
    },
    defaultProps: {
      type: Object,
      default:() => {
        return {
          children: "children",
          label: "label"
        };
      }
    }
  },

  data() {
    return {
      key: `TreeCustom-${Math.random()
        .toString(36)
        .slice(2)}`,
      defaultCheckedkeys:[]
    };
  },
  computed: {
    _value: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
        this.$emit("change", val);
      }
    }
  },
  watch:{
    value:{
      handler(val,old) {
        if (val.length === 0 && old && old.length === 0) {
          return;
        }
        this.defaultCheckedkeys = val;
        if (this.$refs["tree"]) {
          this.$refs["tree"].setCheckedKeys(val);
        }

      },
      deep:true,
      immediate:true
    }
  },
  methods:{
    handlerCheck(item,data) {
      let val = [...data.checkedKeys];
      if (item.id > 100) {
        //如果勾选按钮 选中父级
        this.options.forEach(m => {
          if (m.lowerMenus) {
            m.lowerMenus.forEach(i => {
              if (i.lowestMenus && i.lowestMenus[0] &&  i.lowestMenus[0].id) {
                i.lowestMenus.forEach(j => {
                  let has =   j.operations.find(j => j.id === item.id);
                  if (has && val.includes(has.id)) {
                    val.push(j.id);
                  }
                });
              } else {
                let has =   i.operations.find(l => l.id === item.id);

                if (has && val.includes(has.id)) {
                  val.push(i.id);
                }
              }
            });
          }
        });

      } else {
        //如果取消父级 把所有自己取消
        this.options.forEach(m => {
          if (m.lowerMenus) {
            m.lowerMenus.forEach(i => {
              if (i.lowestMenus && i.lowestMenus[0] &&  i.lowestMenus[0].id) {
                i.lowestMenus.forEach(j => {
                  let has = j.id === item.id ?j:false;

                  if (has && !val.includes(has.id)) {
                    has.operations.forEach(k => {
                      var index = val.indexOf(k.id);
                      if (index !== -1) {
                        val.splice(index, 1);
                      }
                    });
                  }
                });
              } else {
                let has = i.id === item.id ?i:false;
                if (has && !val.includes(has.id)) {
                  has.operations.forEach(k => {
                    var index = val.indexOf(k.id);
                    if (index !== -1) {
                      val.splice(index, 1);
                    }
                  });
                }

              }
            });
          }
        });

      }

      this.$emit("input", val);
      this.$emit("change", val);
      // console.log(data.checkedKeys,data.halfCheckedKeys);
    }
  }
};
</script>

<style lang="scss" scoped>
    .tree-custom {
        width: 100%;
        background:rgba(237,243,247,1);
        border-radius:4px;
        padding: 10px;
        .el-tree{
            background: none;
        }
    }
</style>
